export var SwapDuration;
(function (SwapDuration) {
    SwapDuration[SwapDuration["RAPID"] = 30] = "RAPID";
    SwapDuration[SwapDuration["NORMAL"] = 60] = "NORMAL";
    SwapDuration[SwapDuration["EXTENSIVE"] = 360] = "EXTENSIVE";
    SwapDuration[SwapDuration["PROLONGED"] = 720] = "PROLONGED";
})(SwapDuration || (SwapDuration = {}));
//# sourceMappingURL=swap-duration.enum.js.map